import { Helmet } from "react-helmet-async";

const SITE_URL = "https://pawtraitpop.art";
const DEFAULT_OG_IMAGE = "https://storage.googleapis.com/gpt-engineer-file-uploads/rtRoNYK3uSU8zDiAerkRwmd6eea2/social-images/social-1776503612365-5f79ee05-5f0f-4529-90cd-5890390dd3d2.webp";

interface SEOProps {
  title: string;
  description: string;
  /** Path relative to site root, e.g. "/merch-digital". Defaults to "/". */
  path?: string;
  image?: string;
  /** JSON-LD structured data object(s) for rich snippets. */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  /** noindex this page (e.g. checkout, cart). */
  noindex?: boolean;
}

/**
 * Reusable SEO head: title (<60 chars), meta description (<160), canonical,
 * Open Graph, Twitter Card, optional JSON-LD structured data.
 */
const SEO = ({ title, description, path = "/", image = DEFAULT_OG_IMAGE, jsonLd, noindex }: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="es_MX" />
      <meta property="og:site_name" content="PAWTRAiT" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
